import React from 'react';
import { PageHeader, Card } from '@/components/Primitives';

const Docs = () => (
    <>
        <PageHeader
            eyebrow="Dokumentace"
            title="Síťové požadavky & integrace"
            description="Co je nutné připravit na straně sítě / PBX pro správné fungování DIDWW telefonní brány."
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <Card title="DIDWW Routing režimy">
                <div className="space-y-3 text-sm">
                    <div>
                        <strong>Static SIP URI:</strong> DIDWW posílá příchozí hovory na pevnou
                        veřejnou SIP URI vašeho PBX/SBC. Vyžaduje veřejně dostupný server s otevřeným
                        SIP portem.
                    </div>
                    <div>
                        <strong>SIP Registration:</strong> Váš PBX se registruje k DIDWW jako klient,
                        DIDWW pak posílá hovory přes navázanou registrace. Funguje i za NAT.
                    </div>
                </div>
            </Card>

            <Card title="Firewall / NAT">
                <ul className="list-disc list-inside text-sm space-y-2">
                    <li>Povolte DIDWW SIP signaling IP rozsahy: <code className="font-mono">185.117.80.0/22</code></li>
                    <li>Otevřete RTP rozsah na PBX (typicky <code className="font-mono">10000–20000/UDP</code>)</li>
                    <li>Při NAT povolte <code className="font-mono">force_rport</code>, <code className="font-mono">rewrite_contact</code></li>
                    <li>Pro TLS/SRTP otevřete TCP/UDP <code className="font-mono">5061</code> a načtěte CA certifikát</li>
                </ul>
            </Card>

            <Card title="Transports">
                <ul className="list-disc list-inside text-sm space-y-2">
                    <li><strong>UDP</strong> – výchozí, nejmenší overhead, používá se s STUN při NAT</li>
                    <li><strong>TCP</strong> – pro fragmentované SIP zprávy (např. velká SDP)</li>
                    <li><strong>TLS</strong> – šifrované signalizační spojení</li>
                    <li><strong>SRTP</strong> – šifrovaný media stream (RTP)</li>
                </ul>
            </Card>

            <Card title="Bezpečnostní doporučení">
                <ul className="list-disc list-inside text-sm space-y-2">
                    <li>DIDWW API klíč je v CMS šifrován pomocí Fernet (AES-128) a nikdy se nezobrazí v UI/API</li>
                    <li>Hesla SIP účtů jsou hashovaná (bcrypt). Plaintext se ukazuje jen jednou při vytvoření.</li>
                    <li>Nastavte <strong>Toll Fraud</strong> limity a whitelist zemí</li>
                    <li>Pravidelně kontrolujte <strong>Audit log</strong> a CDR exporty</li>
                    <li>Pro produkční nasazení použijte <strong>TLS + SRTP</strong></li>
                </ul>
            </Card>

            <Card title="Asterisk integrace">
                <ol className="list-decimal list-inside text-sm space-y-2">
                    <li>Stáhněte <code className="font-mono">pjsip.conf</code> a <code className="font-mono">extensions.conf</code> ze stránky <strong>PBX Konfigurace</strong></li>
                    <li>Nahraďte placeholder hesla SIP klapek skutečnými hodnotami (poskytnuté při vytvoření)</li>
                    <li>Umístěte soubory do <code className="font-mono">/etc/asterisk/</code></li>
                    <li>Spusťte <code className="font-mono">asterisk -rx "pjsip reload"</code> a <code className="font-mono">"dialplan reload"</code></li>
                    <li>Nastavte webhook handler v dialplanu, který bude volat <code className="font-mono">/api/webhooks/*</code></li>
                </ol>
            </Card>

            <Card title="API integrace s vaším CMS (poptavka.solar-green.cz)">
                <p className="text-sm">
                    Tento modul vystavuje plnou REST API pod prefixem <code className="font-mono">/api</code>.
                    Pro pozdější propojení s existujícím adminem CMS solar-green vystačíte s:
                </p>
                <ul className="list-disc list-inside text-sm mt-2 space-y-1">
                    <li><code className="font-mono">POST /api/auth/login</code> – získání JWT</li>
                    <li>Bearer token v <code className="font-mono">Authorization</code> hlavičce u všech volání</li>
                    <li>Kompletní swagger na <code className="font-mono">/docs</code> (FastAPI)</li>
                </ul>
            </Card>
        </div>
    </>
);

export default Docs;
